/**
 * Format a price for display.
 * Under $1M: "$950K"
 * $1M exactly: "$1M"
 * Over $1M: "$1.2M", "$2.5M", etc.
 */
export function formatPrice(value) {
  if (!value || value <= 0) return null;
  if (value >= 1000000) {
    const m = value / 1000000;
    return `$${m % 1 === 0 ? m.toFixed(0) : m.toFixed(1)}M`;
  }
  return `$${(value / 1000).toFixed(0)}K`;
}

/**
 * Format a price range: "$950K – $1.2M"
 */
export function formatPriceRange(min, max) {
  if (!min && !max) return null;
  return `${formatPrice(min)} – ${formatPrice(max)}`;
}
